import SectionHeading from '@/components/feature/SectionHeading';
import { highlights } from '@/mocks/drama';

export default function Highlights() {
  return (
    <section id="highlights" className="bg-foreground-950 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          eyebrow="Why it stands out"
          title="值得一看的六个看点"
          desc="抛开版本差异，这个题材真正吸引人的地方，在于它对关系与情绪的处理方式。"
          align="center"
          light
        />

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {highlights.map((item) => (
            <div
              key={item.title}
              className="rounded-lg border border-background-100/15 bg-background-100/5 p-5 md:p-6 transition-colors hover:border-accent-500/60"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base md:text-lg font-semibold text-background-50">
                {item.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-background-200">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}